import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationEMRCreatePayload,
  ILabReportInterpretationEMRCreateResponse,
  ILabReportInterpretationEMRDocuments,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationEMRCreateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      payload: ILabReportInterpretationEMRCreatePayload,
    ): Promise<(ILabReportInterpretationEMRDocuments & { emr_id: string }) | null> => {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return axios
        .post(LAB_REPORT.LAB_REPORT_INTERPRETATION_EMR_CREATE.baseURL, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ILabReportInterpretationEMRCreateResponse>) => {
          if (res.data?.status === true && res.data?.data?.emr_id) return res.data.data;
          toast.error(res.data?.message || "Unable to start interpretation");
          return null;
        })
        .catch((e: AxiosError<{ message?: string }>) => {
          sendCurl(e.config?.["curlCommand"]);
          toast.error(e.response?.data?.message || "Unable to start interpretation");
          return null;
        });
    },
    [],
  );

  return { execute };
};
